import '../style.css';
import Library from '../lib/Library.js';
import {Map} from '../lib/Map.js';
import {BaseLayer} from '../lib/BaseLayer.js';
import {MapLayer} from '../lib/MapLayer.js';
import {WindTempLayer} from '../lib/layers/WindTemp.js';
import {MousePosition} from '../lib/controls/MousePosition.js';
import {ScaleLine} from '../lib/controls/ScaleLine.js';
import {DateLabel} from '../lib/controls/DateLabel.js';
import {TimeSlider} from '../lib/controls/TimeSlider.js';
import {LevelSlider} from '../lib/controls/LevelSlider.js';

let cur_date = Library.getDate();
console.info( cur_date );

function init(){
    let map = new Map();
    let secs = Library.getSeconds();
    // Round down to nearest 3 hours
    secs = Math.floor(secs / 10800) * 10800;
    console.info( secs );
    map.setInitDate( secs );
    map.addLayer( new BaseLayer( map, {"type": "globe_light"} ));
    map.addLayer( new MapLayer( map, {"type": "basic"}, {"visible": true } ));
    map.addLayer( new MapLayer( map, {"type": "county"} ));
    map.addLayer( new MapLayer( map, {"type": "highway"} ));
    map.addLayer( new MapLayer( map, {"type": "jetroute"} ));
    map.addLayer( new MapLayer( map, {"type": "fir"} ));
    map.addLayer( new WindTempLayer( map, {"visible": true} ));
    map.addControl( new MousePosition( map ));
    map.addControl( new ScaleLine( map ));
    map.addControl( new DateLabel( map ));
    map.addControl( new TimeSlider( map, { 
                "min": 0,
                "max": 24,
                "value": 0,
                "onchange": function( val, date ){
                    console.info( 'slider', val, date );
                }
                } ));
    map.addControl( new LevelSlider( map, { 
                "levels": [ "030", "060", "090", "120", 
                "180", "240", "300", "340", "390", "450", 
                "530" ],
                "value": 0,
                "onchange": function( val, level ){
                    console.info( 'slider', val, level );
                    
                }
                } ));
    map.setupInput();
    map.setLocation();
    map.setTimeout();

    window.map = map;
}

document.addEventListener("DOMContentLoaded", function() {
    init();
});
